import BaseServiceCrud from './BaseServiceCrud';

export default class InternalUserService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'internal-user';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            email: criteria.email,
            first_name: criteria.firstName,
            last_name: criteria.lastName,
            name: criteria.name,
            role: criteria.role?.id,
            roles: criteria.roles,
            active: criteria.active,
            not_blocked: criteria.notBlocked,
            status: criteria.status?.enumValue,
            person: criteria.person?.enumValue,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    updateUserPassword(body) {
        return this.fetch(`${this.domain}/${this.path}/update-password/`, {
            method: 'PUT',
            body: JSON.stringify(body),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getInternalUserReference(id) {
        return this.fetch(`${this.domain}/${this.path}/user-reference/${id}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    checkStatusPassword(login, password, captchaValid) {
        return this.fetch(`${this.domain}/${this.path}/password/check-status-password`, {
            method: 'POST',
            body: JSON.stringify({login, password, captchaValid}),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    updateMyAccount(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/me/${element.id}`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getMyAccount(id) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/me/${id}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    blockAccount(id) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/block/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    removeAccount(id) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/remove/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    unblockAccount(id) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/unblock/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    remindPassword(id, locale) {
        return this.fetch(`${this.domain}/${this.path}/remind-password/${id}/${locale}`, {
            method: 'POST',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getUserType(id) {
        return this.fetch(`${this.domain}/${this.path}/type/${id}`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }
}
